import { isNonEmptyString } from "@clipboard-health/util-ts";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

export function extractErrorDetail(error: unknown): string | undefined {
  if (!isRecord(error)) {
    return undefined;
  }

  let body: unknown;
  if ("response" in error && isRecord(error.response)) {
    body = "data" in error.response ? error.response.data : error.response.body;
  }

  if (isRecord(body)) {
    if ("displayableMessage" in body && isNonEmptyString(body.displayableMessage)) {
      return body.displayableMessage;
    }
    if (
      "errors" in body &&
      Array.isArray(body.errors) &&
      isRecord(body.errors[0]) &&
      isNonEmptyString(body.errors[0].detail)
    ) {
      return body.errors[0].detail;
    }
    if ("message" in body && isNonEmptyString(body.message)) {
      return body.message;
    }
    if ("error" in body && isNonEmptyString(body.error)) {
      return body.error;
    }
  } else if (isNonEmptyString(body) && !body.trimStart().startsWith("<")) {
    // Axios can deliver plain-string error bodies in `response.data` when the
    // backend returns a non-JSON payload. Skip HTML to avoid rendering raw
    // markup in a toast.
    return body;
  }

  // Fall back to superagent's plain-text error body when the structured body
  // is absent or doesn't contain a recognized message field. Skip empty
  // strings and HTML payloads (e.g. 502 gateway pages).
  if (
    "response" in error &&
    isRecord(error.response) &&
    "text" in error.response &&
    isNonEmptyString(error.response.text) &&
    !error.response.text.trimStart().startsWith("<")
  ) {
    return error.response.text;
  }

  if ("message" in error && isNonEmptyString(error.message)) {
    return error.message;
  }

  return undefined;
}
